module.exports = __webpack_public_path__ + "src/assets/video/howToPlayEatHoney.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/howToPlayEatHoney.gif
// module id = ./src/assets/video/howToPlayEatHoney.gif
// module chunks = 0